import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useTryInStore } from '../../hooks/use-try-in-store.js';
import { AddProduct } from './components/AddProduct.js';
import { Footer } from './components/Footer.js';
import { ProductItemContainer } from './components/ProductItemContainer.js';
import { ProductList } from './components/ProductList.js';

var SelectionModal = (_param)=>{
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { getLabel  } = useIntl();
    const [{ products  }, { fetchProducts , storage  }] = useTryInStore();
    var ref;
    const skus = (ref = products === null || products === void 0 ? void 0 : products.map((product)=>product.sku
    )) !== null && ref !== void 0 ? ref : [];
    React.useEffect(()=>{
        fetchProducts();
    }, [
        fetchProducts
    ]);
    return /*#__PURE__*/ React.createElement(Modal, swcHelpers.extends({
        isFullScreen: true,
        isOpen: true
    }, rest, {
        className: classnames('try-in-store-selection-modal', className),
        title: getLabel('tryInStore.component.selectionModal.title'),
        titleVariant: "subheading2",
        showIcon: true,
        footer: (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ React.createElement(Footer, {
            skus: skus
        }) : null
    }), /*#__PURE__*/ React.createElement("div", {
        className: "try-in-store-selection-modal__container"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small"
    }, getLabel('tryInStore.component.selectionModal.title')), /*#__PURE__*/ React.createElement(Text, null, getLabel('tryInStore.component.selectionModal.introduction')), (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ React.createElement(ProductList, null, products.map((product)=>{
        return /*#__PURE__*/ React.createElement(ProductItemContainer, {
            key: product.sku,
            product: product,
            onRemove: storage.remove
        });
    })) : null, !(products === null || products === void 0 ? void 0 : products.length) || products.length < 3 ? /*#__PURE__*/ React.createElement(AddProduct, null) : null, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary",
        variant: "caption"
    }, getLabel('tryInStore.component.selectionModal.disclaimer'))));
};

export { SelectionModal };
//# sourceMappingURL=SelectionModal.js.map
